export const ICON_PATHS = {
  'arrow-left': 'M10 6l-6 6 6 6M4 12h16',
  'arrow-right': 'M14 6l6 6-6 6M4 12h16',
  search: 'M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35',
  menu: 'M3 7h18M3 12h18M3 17h18',
  sun: 'M12 16a4 4 0 100-8 4 4 0 000 8zM12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41',
  moon: 'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  'chevron-left': 'M15 6l-6 6 6 6',
  'chevron-right': 'M9 6l6 6-6 6',
  calendar:
    'M8 3v3M16 3v3M4 9h16M6 5h12a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z',
  'arrow-up': 'M12 19V5M6 11l6-6 6 6',
  'arrow-down': 'M12 5v14M6 13l6 6 6-6',
  sort: 'M8 5v14M8 5L5 8M8 5l3 3M16 19V5M16 19l-3-3M16 19l3-3',
  plus: 'M12 5v14M5 12h14',
  minus: 'M6 12h12',
  edit: 'M13.26 3.6L5.05 12.29C4.74 12.62 4.44 13.27 4.38 13.72L4.01 16.96C3.88 18.13 4.72 18.93 5.88 18.73L9.1 18.18C9.55 18.1 10.18 17.77 10.49 17.43L18.7 8.74C20.12 7.24 20.76 5.53 18.55 3.44C16.35 1.37 14.68 2.1 13.26 3.6ZM11.89 5.05C12.32 7.81 14.56 9.92 17.34 10.2M3 22H21',
  'circle-check': 'M12 22a10 10 0 100-20 10 10 0 000 20zM8 12.5l3 3 5-6',
  inbox: 'M3 13l3-8h12l3 8v6H3zM3 13h5l1 3h6l1-3h5',
  clock: 'M12 22a10 10 0 100-20 10 10 0 000 20zM12 7v5l3 2',
  bag: 'M5 8h14l-1 12H6zM9 8a3 3 0 016 0',
  box: 'M12 2.5l8 4.5v10l-8 4.5-8-4.5V7zM4 7l8 4.5L20 7M12 21.5v-10',
  close: 'M6 6l12 12M18 6L6 18',
  printer:
    'M7 9V3h10v6M7 17H5a2 2 0 01-2-2v-4a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2h-2M7 14h10v7H7z',
  'printer-off':
    'M7 9V3h10v6M7 17H5a2 2 0 01-2-2v-4a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2h-2M7 14h10v7H7zM3 21L21 3',
  scale: 'M3 7h18l-2 13H5L3 7zM9 7a3 3 0 016 0M12 11l2 3',
  card: 'M3 6h18v12H3zM3 10h18M7 15h3',
} as const;

export type PdsIconName = keyof typeof ICON_PATHS;
